import InputValidationContent from './InputValidationContent';

export default InputValidationContent;
